import React from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../styles/utils';

/* Единственный компонент, где цвета оставались сырыми: подвал
   не попал ни в один из прошлых заходов по токенам. */
const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.surfaceGray};
  border-top: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
  padding: ${pxToRem(8)} 0;
  width: 100%;
  position: relative;
  z-index: 1;
`;

const FooterContent = styled.div`
  max-width: ${pxToRem(1200)};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(16)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  white-space: nowrap;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <span>ИП Сычев Евгений Вадимович</span>
        <span>•</span>
        <span>ОГРНИП: 323420500074490</span>
        <span>•</span>
        <span>ИНН: 421415966679</span>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;